import { useContext } from 'react'

import DescendantOfMapContext from '../contexts/DescendantOfMapContext'

const useIsDescendantOfMap = () => {
  const isDescendantOfMap = useContext(DescendantOfMapContext)
  return isDescendantOfMap
}

export default useIsDescendantOfMap
